import { doc, onSnapshot } from 'firebase/firestore';
import { RESTRICTED_CONFIG_DOC_ID } from '@daaily/shared';
import { db } from './firebase';

/**
 * Live /config/restricted (compensation figures, security audit Oct 2026). Only
 * admins and commission/USL managers may read it; for everyone else the listener
 * is refused and `onData` gets `{}`, so merged config simply lacks those fields.
 */
export function subscribeRestrictedConfig(onData: (data: Record<string, unknown>) => void): () => void {
  return onSnapshot(
    doc(db, 'config', RESTRICTED_CONFIG_DOC_ID),
    (snap) => onData(snap.exists() ? (snap.data() as Record<string, unknown>) : {}),
    () => onData({}),
  );
}
